import { render, staticRenderFns } from "./DamageClaim.vue?vue&type=template&id=f847257e&"
import script from "./DamageClaim.vue?vue&type=script&lang=js&"
export * from "./DamageClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports